<template>
  <div class="home">
    <img src="../assets/home.png" mode="widthFix" class="home_image" />
    <div class="home_body flex">
      <img :src="config.website_wxcode" class="home_ewm" mode="" />
      <div class="">
        <div class="home_h1">亲！您知道吗？</div>
        <div class="home_h2">您的书可能价值百万呢~</div>
        <div class="home_h3">快来扫码关注，看看您书的价值吧~</div>
      </div>
    </div>
    <div class="home_foot">
      <div class="flex">
        <img src="../assets/phone.png" mode="" />
        <div class="">
          <div class="foot_h1">闲置书籍太多，废品价格太低怎么办？</div>
          <div class="foot_h1" style="margin: 30px 0;">正版新书价格太高。资金不够怎么办？</div>
          <div class="foot_h1">伴您多时的书籍舍不得扔，</div>
          <div class="foot_h1" style="margin-top: 30px;">想给他寻找更好的归宿怎么办？</div>
          <div class="foot_h2">有了循卷二手旧书回收收书，这些都不是问题哦~</div>
        </div>
      </div>
      <div class="flex foot_btn">
        <div class="flex">
          <router-link :to="{path:'/sell'}">了解如何卖书></router-link>
        </div>
        <div class="flex">
          <router-link :to="{path:'/buy'}">了解如何买书></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      config:{}
    };
  },
  methods:{
    sysConfig() {
      this.$postRequest("/sysConfig",{
        keys:[
            "website_wxcode",
            "website_phone",
            "website_wx",
            "website_qq",
            "website_address"
        ]
      }).then((res) => {
        this.config = res.data;
      });
    }
  },
  created(){
    this.sysConfig();
  }
};
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.home_foot{
  width: 100%;
  height: 988px;
  background-color: #ffffff;
  padding-top: 34px;
  box-sizing: border-box;
  img {
    width: 445px;
    height: 566px;
    margin-right: 121px;
  }
  div {
    text-align: left;
  }
  .foot_h1 {
    font-size: 35px;
    font-weight: bold;
  }
  .foot_h2 {
    margin-top: 62px;
    color: #698C6C;
    font-size: 45px;
    font-weight: bold;
  }
  .foot_btn {
    margin-top: 105px;
    div {
      width: 500px;
      height: 110px;
      border-radius: 80px;
      background: #698C6C;
      color: #FFF7EA;
      font-size: 45px;
      margin-right: 134px;
      cursor: pointer;
      overflow: hidden;
    }
    a{
      color: #FFF7EA;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
    }
  }
}
.home_body {
  width: 100%;
  height: 816px;
  background: linear-gradient(180deg, #fff7ea 0%, #fffbf8 100%);
  img {
    width: 500px;
    height: 500px;
    margin-right: 103px;
  }
  .home_h1 {
    font-size: 80px;
    color: #698C6C;
    font-weight: bold;
  }
  .home_h2 {
    font-size: 60px;
    color: #333333;
    font-weight: bold;
    margin: 36px 0 52px;
  }
  .home_h3 {
    font-size: 45px;
  }
}
.home {
  width: 100%;
}
.home_image {
  width: 100%;
  display: block;
}
</style>
